module.exports = __webpack_public_path__ + "img/social-telegram.16149eec.svg";